import styled from "styled-components"

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.blueyGrey60};
  z-index: 100;
`;

export const ModalBodyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  min-height: 100%;
`

export const ModalBody = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.whiteTwo};
  max-width: 350px;
  width: 100%;
  height: 100%;
`;

export const CloseButton = styled.span`
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;

  &:hover,
  &:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
`;